import { useEffect, useRef } from "react";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

const Finances = () => {

    const table1 = useRef(null);

    useEffect(() => {
        window.JSZip = jszip;

        let table11

        if (table1.current) {
            table11 = $(table1.current).DataTable({
                responsive: true,
                pageLength: 5,
                lengthChange: false,
                ordering: true,
                destroy: true,
                dom:
                    "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
                    "<'row'<'col-sm-12'tr>>" +
                    "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
                buttons: [
                    { extend: "copy", text: "Copy" },
                    { extend: "excel", text: "Excel" },
                    { extend: "pdf", text: "PDF" },
                    { extend: "print", text: "Print" },
                ],
            });
        }
        return () => {
            if (table11) table11.destroy();
        };
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Payments</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Payments</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <div className="entries-wrapper mb-3">
                                    <label className="entries-label">
                                        <span>Showing</span>
                                        <select className="entries-select">
                                            <option value={10} selected>10</option>
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                        </select>
                                        <span>Entries</span>
                                    </label>
                                </div>
                                <table ref={table1} className="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Game ID</th>
                                            <th>Game Date</th>
                                            <th>Referee Pay</th>
                                            <th>Total Amount</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>555AA</td>
                                            <td>22 Aug 2025</td>
                                            <td>$300</td>
                                            <td>$500</td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start gap-2">
                                                    <li>
                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#view_proposal_modal">
                                                            <i className="lni lni-eye" data-bs-toggle="tooltip" data-bs-placement="top" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="">
                                                            <i className="bx bx-download" data-bs-toggle="tooltip" data-bs-placement="top" title="Download">
                                                            </i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>556BB</td>
                                            <td>23 Aug 2025</td>
                                            <td>$400</td>
                                            <td>$600</td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start gap-2">
                                                    <li>
                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#view_proposal_modal">
                                                            <i className="lni lni-eye" data-bs-toggle="tooltip" data-bs-placement="top" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="">
                                                            <i className="bx bx-download" data-bs-toggle="tooltip" data-bs-placement="top" title="Download">
                                                            </i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>557CC</td>
                                            <td>24 Aug 2025</td>
                                            <td>$150</td>
                                            <td>$450</td>
                                            <td>
                                                <ul className="tbl_actions_wrap d-flex align-items-center justify-content-start gap-2">
                                                    <li>
                                                        <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#view_proposal_modal">
                                                            <i className="lni lni-eye" data-bs-toggle="tooltip" data-bs-placement="top" title="View" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="">
                                                            <i className="bx bx-download" data-bs-toggle="tooltip" data-bs-placement="top" title="Download">
                                                            </i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="view_proposal_modal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Payment Overview</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" />
                        </div>
                        <div className="modal-body profile_modal_wrap">
                            <form>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4">
                                        <h6 className="mb-0">Game ID</h6>
                                    </div>
                                    <div className="col-sm-8 text-secondary">
                                        <input type="text" className="form-control" defaultValue="555AA" readOnly />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4">
                                        <h6 className="mb-0">Game Date</h6>
                                    </div>
                                    <div className="col-sm-8 text-secondary">
                                        <input type="text" className="form-control" defaultValue="Aug 22, 2025" readOnly />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4">
                                        <h6 className="mb-0">Refree Pay</h6>
                                    </div>
                                    <div className="col-sm-8 text-secondary">
                                        <input type="text" className="form-control" defaultValue="$300" readOnly />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4">
                                        <h6 className="mb-0">Total Amount</h6>
                                    </div>
                                    <div className="col-sm-8 text-secondary">
                                        <input type="text" className="form-control" defaultValue="$500" readOnly />
                                    </div>
                                </div>
                                <div className="row mb-3 align-items-center">
                                    <div className="col-sm-4">
                                        <h6 className="mb-0">Payout Status</h6>
                                    </div>
                                    <div className="col-sm-8 text-secondary">
                                        <input type="text" className="form-control" defaultValue="Paid" readOnly />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Finances